<template>
  <b-container fluid>
    <b-row>
      <b-col sm="12" md="7" lg="5" id="login-form" class="p-3 p-lg-4 p-xl-5">
        <b-row>
          <b-col cols="12" md="4" class="text-center text-lg-left py-3" align-self="center">
            <img :src="$store.getters.universe.logoLogin" :alt="$store.getters.universe.siteName" style="height: 100%; max-height: 50px; width: auto; max-width: 150px;">
          </b-col>
          <b-col cols="12" md="8" class="text-center text-md-right text-muted py-3 py-md-5" align-self="center">
            <b-link :to="{ name: 'login' }" class="text-uppercase" style="vertical-align:baseline">
              <strong>
                <translate>Back to login</translate>
              </strong>
            </b-link>
          </b-col>
        </b-row>

        <b-row class="py-3">
          <b-col class="text-center text-md-left">
            <h2 v-translate>Reset forgotten password</h2>
            <p v-translate v-show="sent === false">Please enter your email</p>
            <br>
            <form @submit.prevent="send()" class="form form--login grid" v-show="sent === false">
              <div class="form-group label-floating">
                <input type="email" :placeholder="$gettext('E-mail')" class="form-control" id="login__email" v-model="email" required>
              </div>
              <br>
              <b-row>
                <b-col cols="12" class="text-center text-md-right">
                  <button type="submit" class="btn btn-lg btn-primary"><strong v-translate>Send reset email</strong></button>
                </b-col>
              </b-row>
            </form>
            <b-alert variant="success" show v-show="sent !== false"><span v-translate>The email has been sent. Please check your inbox and follow the instructions to reset your password.</span></b-alert>
            <br>
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="12" md="5" lg="7" id="login-bg" :class="'d-none d-md-block ' + $store.getters.universe.bgLogin || ''">

      </b-col>
    </b-row>
    <span class="d-none" v-translate>E-mail</span>
  </b-container>
</template>

<script>
  import ApiService from '@/common/api.service'

  export default {
    name: 'PasswordEmailPage',
    title() {
      return this.$gettext('Reset forgotten password')
    },
    data () {
      return {
        email: '',
        sent: false
      }
    },
    methods: {
      send () {
        if (this.email !== '') {
          ApiService.post('password/email', {email: this.email})
            .then(response => {
              this.sent = true
            })
            .catch(error => {
              let mssg = ''
              if (typeof error.body.errors !== 'undefined') {
                for (let i = 0; i < error.body.errors.length; i++) {
                  mssg += error.body.errors[i].detail + '<br>'
                }
              } else {
                mssg = this.$gettext('The email was not found') // error.body.message
              }
              let obj = {
                title: 'ERROR',
                message: mssg,
                type: 'error',
                customCloseBtnText: this.$gettext('Close')
              }
              console.log(this.$root)
              this.$root.$children[0].$refs.simplert.openSimplert(obj)
            })
          console.log(this.email)
        }
      }
    }
  }
</script>
